import styled from 'styled-components';

const Title = styled.strong`
  display: block;
  margin-bottom: 25px;
  margin-top: 4px;
  text-align: center;
  color: #fff;
  font-weight: 300;
  font-size: var(--font-size-l);
`;

export default Title;
